import { Observable } from 'rxjs';
import { UserOperationsRepository } from '../domain/UserOperations/repository';
import { User, UserRequest } from '../domain/user/model';
import { Subscription } from '../domain/suscriptions/model'; // Import Subscription model
import HttpClient from '../utils/http-client';

export class UserOperationsRepositoryImplementation extends UserOperationsRepository {
  private httpClient: HttpClient;

  constructor() {
    super();
    // The HttpClient constructor expects uid and cid.
    // For operations that don't directly involve a specific user's uid/cid in the constructor,
    // these might be passed in the method calls or retrieved from context.
    // For now, I'll use placeholders as in the existing code.
    this.httpClient = new HttpClient('', '');
  }

  create(user: UserRequest): Observable<User> {
    return this.httpClient.post('/operations/users', user); // Assuming API endpoint for creating users
  }

  getById(id: number): Observable<User> {
    return this.httpClient.get(`/operations/users/${id}`); // Assuming API endpoint for getting a user by ID
  }

  getUsers(page: number, limit: number): Observable<User[]> {
    return this.httpClient.get(`/operations/users?page=${page}&limit=${limit}`); // Assuming API endpoint for listing users
  }

  updateById(id: number, user: Partial<User>): Observable<User> {
    return this.httpClient.put(`/operations/users/${id}`, user); // Assuming API endpoint for updating a user by ID
  }

  delete(id: number): Observable<void> {
    return this.httpClient.delete(`/operations/users/${id}`); // Assuming API endpoint for deleting a user by ID
  }

  createSubscription(subscription: Partial<Subscription>): Observable<Subscription> {
    return this.httpClient.post('/operations/subscription', subscription);
  }

  updateSubscription(subscription: Partial<Subscription>): Observable<Subscription> {
    return this.httpClient.put('/operations/subscription', subscription);
  }

  getSubscription(id: number): Observable<Subscription> {
    return this.httpClient.get(`/operations/subscription/${id}`);
  }

  getDocumentPackages(userId: number, page: number, limit: number): Observable<any> {
    return this.httpClient.get(`/operations/users/${userId}/document-packages?page=${page}&limit=${limit}`);
  }

  addDocumentPackage(payload: { users_id: number, quantity: number, marketplace_package_id: number }): Observable<any> {
    const { users_id, ...rest } = payload;
    return this.httpClient.post(`/operations/users/${users_id}/document-packages`, rest);
  }

  getAvailablePackages(page: number, limit: number): Observable<any> {
    return this.httpClient.get(`/operations/document-packages/catalog?page=${page}&limit=${limit}`);
  }

  initializeConfig(userId: number): Observable<any> {
    return this.httpClient.post(`/operations/users/${userId}/initialize-config`, {});
  }
}
